import React from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';
import colors from '../styles/colors';
import { Navbar, Nav, Button } from 'react-bootstrap'

const BaseNavigation = ({ className, onExpand }) => (
  <div className={className}>
    {/* <Link to="/" activeClassName="active">
      Home
    </Link> */}
    <Navbar className="navWrapper" collapseOnSelect expand="xl" variant="light" onToggle={onExpand}> 
      {/* <Navbar.Brand>Indy Steel</Navbar.Brand> */}
      <Navbar.Toggle as={Button} className="navToggler" variant="primary" aria-controls="responsive-navbar-nav" />
      <Navbar.Collapse className="mr-auto" >
        <Nav >
          <Nav.Item as={Link} to='/who-we-are/' activeClassName='active'>
            Who we are
          </Nav.Item>
          <Nav.Item as={Link} to='/what-we-do/' activeClassName='active'>
            What we do
          </Nav.Item>
          <Nav.Item as={Link} to='/projects/' activeClassName='active'>
            Projects
          </Nav.Item>
          <Nav.Item as={Link} to='/safety/' activeClassName='active'>
            Safety
          </Nav.Item>
          <Nav.Item as={Link} to='/quality/' activeClassName='active'>
            Quality
          </Nav.Item>
          <Nav.Item as={Link} className='last' to='/contact-us/' activeClassName='active'>
            Contact Us
          </Nav.Item>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  </div>
);

const Navigation = styled(BaseNavigation)`
  max-width: 900px;

  a {
    border-top: 3px solid transparent; 
    text-transform: uppercase;
    margin-right: 50px;
    text-decoration: none;
    color: ${colors.darkGray};
    display: inline-block;
    padding-top: 3px;
    margin-top: 5%;
    
    &.last {
      margin-right: 10px;
    }
    @media screen and (max-width: 1199px) {
      text-align: right;
      margin-right: 5px;
      &.last {
        margin-right: 5px;
        margin-bottom: 5%;
      }
    }
    @media screen and (max-width: 576px) {
      margin-right: 5px;
      &.last {
        margin-right: 5px;
      }
    }
    
  }

  .navToggler {
    align-self: flex-end;
  }
  .navWrapper {
    display: flex;
    place-content: flex-end;
    
  }
  a:hover {
    border-top: 3px solid ${colors.red};
  }
  a.active {
    border-top: 3px solid ${colors.red};
  }

  @media screen and (max-width: 1286px) {
    a.nav-item {
      margin-top:2.5%;
    }
  }

  @media screen and (max-width: 1200px) {
    .mr-auto {
      position: relative;
      z-index: 1002;
      background: ${colors.lightBlue};
      align-self: flex-end;
      height: 100%;
      top: 1%;
    }
    a:hover, a.active {
      border-top: none;
      border-right: 3px solid ${colors.red};
      padding-right: 5px;
    }
  }
`;

export default Navigation;
